import { ApiResponse } from '../types'
import { AxiosClient } from '../utils/clients'

export type SendOtpResponseData = {
    requestId: string
    prefix: string
}

export type SendOtpPayload = {
    phoneNumber: string
    countryCode: string
}

export type VerifyOTPPayload = {
    code: string
    prefix: string
    requestId: string
}

export type Userprofile = {
    id: string
    mobileNumber: string
    phoneNumber: string
    fullname: string | null
    createdAt: string
    updatedAt: null | string
    profilePicture: null | string
    ghanaCardId: string
    ghanaCardName: string
    isGhanaCardVerified: boolean
    ghanaCardRegistrationDate: null | string
    ghqrCode: null | string
    fcmId: string
    gender: string
    dateOfBirth: null | string
    email: string
    isManuallyVerified: false
    nationality: null | string
    tin: null | string
}

export type UserprofileResponse = ApiResponse<Userprofile>

const BASE_URL = 'https://api-ecg-auth.gov-gh.com'

export default class AuthRepository {
    client: AxiosClient
    serverClient: AxiosClient
    constructor(client: AxiosClient, serverClient: AxiosClient) {
        this.client = client
        this.serverClient = serverClient
    }

    sendOTP(payload: SendOtpPayload): Promise<{ data: ApiResponse<SendOtpResponseData> }> {
        return this.client.post(`/api/send-otp`, payload)
    }

    reSendOTP(payload: Pick<VerifyOTPPayload, 'requestId'>): Promise<{ data: ApiResponse<SendOtpResponseData> }> {
        return this.client.post(`/api/resend-otp`, payload)
    }

    async getUserprofile() {
        const res = await this.client.get<UserprofileResponse>('https://api-ecg-accounts.gov-gh.com/accounts/me')
        return res.data
    }

    async updateUserEmail(emai: string) {
        const res = await this.client.patch<UserprofileResponse>('https://api-ecg-accounts.gov-gh.com/accounts/email', {
            content: emai,
        })
        return res.data
    }

    async postpaidBillQrCodeAuth(phoneNumber: string) {
        const res = await this.serverClient.get<ApiResponse<{ phoneNumber: string }>>(
            `${BASE_URL}/PostPaidBillQrCodeAuth?phoneNumber=${phoneNumber}`,
        )
        return res.data
    }
}
